// ** React Imports
import {
  Fragment, useEffect
  // , useState, useEffect 
} from "react"
// ** Custom Components
import NavbarUser from "./NavbarUser"
import NavbarDropdown from "./NavbarDropdown"
// ** Third Party Components
import { Sun, Moon, Menu } from "react-feather"
import {
  // useNavigate, 
  useLocation
} from "react-router-dom"
// ** Reactstrap Imports
import { NavItem, NavLink, Button } from "reactstrap"
// import { isUserLoggedIn } from "@utils"
import {
  handleMenuCollapsed
} from "../../../../redux/layout"
// ** Config
// import themeConfig from "../../../../configs/themeConfig"
// ** Store & Actions
import { useDispatch } from "react-redux"
import GlobalVariable from "../../../../settings/global"
const headerText = GlobalVariable.headerText

const ThemeNavbar = (props) => {
  const dispatch = useDispatch()
  const location = useLocation()
  // ** Props
  const { skin, setSkin, menuCollapsed
    // , setMenuVisibility 
  } = props
  // const navigate = useNavigate()
  // const [titleName, setTitle] = useState('')

  // ** Function to toggle Theme (Light/Dark)
  const ThemeToggler = () => {
    if (skin === "dark") {
      return <Sun className="ficon" onClick={() => setSkin("light")} />
    } else {
      return <Moon className="ficon" onClick={() => setSkin("dark")} />
    }
  }

  // useEffect(() => {
  //   if (isUserLoggedIn()) {
  //     if (JSON.parse(isUserLoggedIn()).isEmployee) {
  //       setTitle('Workorders')
  //     } else {
  //       setTitle('Dashboard')
  //     }
  //   }
  // }, [isUserLoggedIn()])

  // const navigateMainPage = () => {
  //   sessionStorage.setItem('pageTransition', 'LR')
  //   navigate('/search')
  // }
  const trueBool = true

  useEffect(() => {
    if (menuCollapsed) {
      document.documentElement.style.setProperty('--padding', '0 7rem 0 0.5rem')
    } else {
      document.documentElement.style.setProperty('--padding', '0 13rem 0 0.5rem')
    }
  }, [menuCollapsed])

  return (
    <Fragment>
      <div className="bookmark-wrapper">
        <ul className="navbar-nav d-none">
          <NavItem className="mobile-menu me-auto">
            <NavLink
              className={menuCollapsed ? "nav-menu-main menu-toggle  hidden-xs is-active" : "nav-menu-main menu-toggle hidden-xs is-active p-0"}
              onClick={() => {
                // setMenuVisibility(true)
                dispatch(handleMenuCollapsed(menuCollapsed ? false : trueBool))
              }}
            >
              <Button
                className="btn-icon btn_Action btn_Action_Icon toggle-icon m-0 addiconmenu"
                color="secondary"
                style={{ top: headerText ? '22px' : '10px' }}
              >
                <Menu className="ficon" size={24} />
              </Button>
            </NavLink>
          </NavItem>
        </ul>

        <div className="navbar-header" style={{ marginLeft: '0px' }}>
          <ul className="nav navbar-nav flex-row">
            <li className="nav-item">
              <div className="portal_name">
                <div className={headerText ? "portal_name_env_show" : "portal_name_env_show"}>Corporate Portal</div>
                {headerText && <span className="env_class">{headerText}</span>}
              </div>
            </li>
          </ul>
        </div>

        {/* <div className="work_order_lable">{titleName}</div> */}

        {/* <NavItem className="d-none d-lg-block">
          <NavLink className="nav-link-style">
            <ThemeToggler />
          </NavLink>
        </NavItem> */}
        {location.pathname === '/dashboard' &&
          <ul className="navbar-nav">
            <NavbarDropdown />
          </ul>
        }
      </div>
      <NavbarUser skin={skin} setSkin={setSkin} />
    </Fragment>
  )
}

export default ThemeNavbar
